//
//
//
//
//
//

export default {
  name: 'VCardHeader',
}
